import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import reducerGenerator from '../hierarchyAssignmentsEditor/reducerGenerator'

const hierarchyAssignmentsEditorReducer = reducerGenerator({
    actionTypes: ActionTypes
})

const workAssignmentsEditor = handleActions(hierarchyAssignmentsEditorReducer.handlers, hierarchyAssignmentsEditorReducer.initialState)
export default workAssignmentsEditor


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsEditor/reducer.js